import Handsontable from 'handsontable';

export function scrollToEndTable(hotInstance: Handsontable) {
  hotInstance.scrollViewportTo(0, hotInstance.countCols() - 1);
}
